import { z, chain, asset, numericString, numericOrEmptyString, hexStringWithMaxByteSize } from './chunk-QNH6727P.mjs';

// ../shared/src/schemas.ts
z.object({
  srcChain: chain,
  srcAsset: asset,
  destChain: chain,
  destAsset: asset,
  amount: numericString,
  brokerCommissionBps: numericOrEmptyString.transform((v) => Number(v)).optional(),
  boostFeeBps: numericOrEmptyString.transform((v) => Number(v)).optional()
});
var ccmMetadataSchema = z.object({
  gasBudget: numericString,
  message: hexStringWithMaxByteSize(1024 * 10)
});
z.object({
  srcAsset: asset,
  destAsset: asset,
  srcChain: chain,
  destChain: chain,
  destAddress: z.string(),
  amount: numericString,
  ccmMetadata: ccmMetadataSchema.optional(),
  boostFeeBps: z.number().optional()
}).transform(({ amount, ...rest }) => ({
  ...rest,
  expectedDepositAmount: amount
}));

export { ccmMetadataSchema };
